import React, { useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Stack,
  Step,
  StepLabel,
  Stepper,
  ButtonGroup,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";

import MaterialBox from "../../../../components/MaterialBox";
import { createUploadLink } from "apollo-upload-client";
import { useState } from "react";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import PersonalInformation from "./components/PersonalInformation";
import EmployeeInformation from "./components/EmployeeInformation";
import PFDetails from "./components/PFDetails/index";
import BankDetails from "./components/BankDetails";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import axios from "axios";
import BASEURL, { MEDIAURL } from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import { useUserDetails } from "../../../../context/auth";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useLoading } from "../../../../context/loading";

import SalaryDetails from "./components/SalaryDetails";
import { fetchAll } from "../../../../ApiBaseUrl";
import { ApolloClient, gql, InMemoryCache } from "@apollo/client";

const AddEmployee = () => {
  let userid = sessionStorage.getItem("user");
  const addedId = JSON.parse(userid);
  const navigate = useNavigate();
  const { validationMessages, setValidationMessages, AccessData, EmpSubmit } =
    useUserDetails();

  const [steps, setStep] = useState([
    "Personal info",
    "Official info",
    "Salary Details",
    "Bank Details",
    "PF & ESI Details",
  ]);

  const [activeStep, setActiveStep] = useState(0);

  const { circleLoading, setCirleLoading } = useLoading();
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [resources, setResources] = useState({
    salutation: [
      { value: "Mr.", label: "Mr." },
      { value: "Ms.", label: "Ms." },
      { value: "Mrs.", label: "Mrs." },
      { value: "Dr.", label: "Dr." },
    ],
    gender: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "Others", label: "Others" },
    ],
    martialstatus: [
      { value: "Single", label: "Single" },
      { value: "Married", label: "Married" },
      { value: "Divorced", label: "Divorced" },
      { value: "Separated", label: "Separated" },
      { value: "Widowed", label: "Widowed" },
    ],
    shifts: [
      { value: "Regular", label: "Regular" },
      { value: "Night", label: "Night" },
    ],
    employeeType: [
      { value: "Employee", label: "Employee" },
      { value: "Intern", label: "Intern" },
    ],
    reportManager: [],
    department: [],
    designation: [],
  });

  const probationOptions = [...Array(12)].map((_, index) => {
    const month = index + 1;
    return {
      value: `${month} Month${month > 1 ? "s" : ""}`,
      label: `${month} Month${month > 1 ? "s" : ""}`,
    };
  });

  const emptype = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];

  const typedata = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
    // {value:"Probation",label:"Probation"},
  ];

  const [reportManager, setReportManager] = useState([]);
  const [department, setDepartment] = useState([]);
  const [allbranchnames, setallbranchnames] = useState([]);
  const [designation, setDesignation] = useState([]);
  const [role, setRole] = useState("");
  const [shiftdata, setshiftdata] = useState([]);
  const [branchdata, setBranchdata] = useState([]);
  const [maxStep, setMaxStep] = useState(4);
  const [id, setid] = useState("");

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });
  const [employeeData, setEmployeeData] = useState({
    //personal information
    salutation: null,
    activeuser: false,
    firstName: "",
    lastName: "",
    fathername: "",
    userName: "",
    dob: "yyyy-mm-dd",
    gender: null,
    martialstatus: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    countryCode: null,
    contactNumber: "",
    emergencyNumber: "",
    email: "",
    aadharnumber: "",
    pannumber: "",
    lastworking: "",
    role: "",
    aadharImage: null,
    panImage: null,
    nomineeAadharImage: null,
    nomineeName: "",
    nomineeRelation: "",
    //employee information
    attendanceId: "",
    employeeId: "",
    joiningDate: "yyyy-mm-dd",
    grade: "",
    reportingManager: null,
    employeeType: null,
    categoryType: null,
    shifts: "",
    branch: "",
    previousExperience: "",

    probationPeriod: false,
    user: false,
    isuser: false,
    employee: true,
    //salary information
    basicAmount: "",
    daAmount: "",
    mealsAmount: "",
    hraAmount: "",
    otAmount: "",
    shiftPaisa: "",
    attendanceAmount: "",
    busFare: "",
    isIfscVerify: "",
    //bank information
    accountnumber: "",
    bankname: "",
    enterIfsc: "",
    cifnumber: "",
    branchname: "",
    isIfscVerify: "",
    pfamount: "",
    esiamount: "",
    //PF & ESI Details
    uannumber: "",
    memberid: "",
    esicnumber: "",
    bankPassbookImage: null,
    //personal information status
    salutationStatus: "unchecked",
    firstNameStatus: "unchecked",
    lastNameStatus: "unchecked",
    fathernameStatus: "unchecked",
    userNameStatus: "unchecked",
    dobStatus: "unchecked",
    genderStatus: "unchecked",
    pfamountStatus: "unchecked",
    esiamountStatus: "unchecked",
    martialstatusStatus: "unchecked",
    addressStatus: "unchecked",
    countryStatus: "unchecked",
    stateStatus: "unchecked",
    stateStatus: "unchecked",
    roleStatus: "unchecked",
    zipcodeStatus: "unchecked",
    countryCodeStatus: "unchecked",
    contactNumberStatus: "unchecked",
    emergencyNumberStatus: "unchecked",
    emailStatus: "unchecked",
    officialmailidStatus: "unchecked",
    shiftsStatus: "unchecked",
    branchStatus: "unchecked",
    aadharnumberStatus: "unchecked",
    pannumberStatus: "unchecked",
    nomineeNameStatus: "unchecked",
    nomineeRelationStatus: "unchecked",
    //employee information status
    attendanceIdStatus: "unchecked",
    employeeIdStatus: "unchecked",
    joiningDateStatus: "unchecked",
    gradeStatus: "unchecked",
    reportingManagerStatus: "unchecked",
    employeeTypeStatus: "unchecked",
    categoryTypeStatus: "unchecked",
    departmentStatus: "unchecked",
    designationStatus: "unchecked",
    previousExperienceStatus: "unchecked",
    //salary information status
    basicAmountStatus: "unchecked",
    daAmountStatus: "unchecked",
    mealsAmountStatus: "unchecked",

    otAmountStatus: "unchecked",
    shiftPaisaStatus: "unchecked",
    attendanceAmountStatus: "unchecked",
    busFareStatus: "unchecked",
    //bank information status
    accountnumberStatus: "unchecked",
    banknameStatus: "unchecked",
    enterIfscStatus: "unchecked",
    cifnumberStatus: "unchecked",
    branchnameStatus: "unchecked",
    isIfscVerifyStatus: "unchecked",

    hraAmountStatus: "unchecked",

    //pf & esic information Status
    uannumberStatus: "",
    memberidStatus: "",
    esicnumberStatus: "",
  });
  console.log(employeeData, "employeeData");

  const [originalWeekoffData, setOriginalWeekoffData] = useState({
    //personal information
    salutation: null,
    activeuser: false,
    firstName: "",
    lastName: "",
    fathername: "",
    userName: "",
    dob: "yyyy-mm-dd",
    gender: null,
    martialstatus: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipcode: "",
    countryCode: null,
    contactNumber: "",
    emergencyNumber: "",
    email: "",
    aadharnumber: "",
    pannumber: "",
    lastworking: "",
    role: "",
    aadharImage: null,
    panImage: null,
    nomineeAadharImage: null,
    nomineeName: "",
    nomineeRelation: "",
    //employee information
    attendanceId: "",
    employeeId: "",
    joiningDate: "yyyy-mm-dd",
    grade: "",
    reportingManager: null,
    employeeType: null,
    categoryType: null,
    shifts: "",
    branch: "",
    previousExperience: "",

    probationPeriod: false,
    user: false,
    isuser: false,
    employee: true,
    //salary information
    basicAmount: "",
    pfamount: "",
    esiamount: "",
    daAmount: "",
    mealsAmount: "",
    otAmount: "",
    shiftPaisa: "",
    attendanceAmount: "",
    busFare: "",
    isIfscVerify: "",
    //bank information
    accountnumber: "",
    bankname: "",
    enterIfsc: "",
    cifnumber: "",
    branchname: "",
    isIfscVerify: "",
    bankPassbookImage: null,
    //PF & ESI Details
    uannumber: "",
    memberid: "",
    esicnumber: "",
  });

  const [roledata, setroledata] = useState([]);

  useEffect(() => {
    setValidationMessages("");
    getshiftsdata();
    getroles();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    if (id) {
      setid(id);
      getemployeedata(id);
    }
  }, [roledata]);

  useEffect(() => {
    const fetchBranches = async () => {
      setCirleLoading(true);
      try {
        const fields = [
          "id",
          "name",
          "description",
          "address",
          "state",
          "zipCode",
          "branchIncharge",
        ];
        const data = await fetchAll("Branch", fields);
        let result = data?.allBranch;
        let filterdata = result.map((val) => {
          return {
            value: val.id,
            label: val.name,
          };
        });
        setallbranchnames(filterdata);
      } catch (error) {
        console.error("Error fetching branches:", error);
      } finally {
        setCirleLoading(false);
      }
    };

    fetchBranches();
  }, []);

  const getshiftsdata = async () => {
    const query = `
              query allShifts{
  allShifts {
    id
    name
    startTime
    endTime
  }
}
              `;

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      let val = response.data?.data?.allShifts;
      setshiftdata(val);
      // setCirleLoading(false)
    } catch (error) {
      console.error("ResponseError:", error);
      // setCirleLoading(false)
    }
  };

  const getroles = async () => {
    // setCirleLoading(true)
    const query = `query{
   allRoles{
     data{
       id
       role
       description
     }
   }
 }`;
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // setCirleLoading(false)
      const wfhList = response.data.data.allRoles[0]?.data;
      setroledata(wfhList);
    } catch (error) {
      console.log("Error:", error);
      // setCirleLoading(false)
    }
  };

  const handleEmployeeDataChange = (event, selectEvent) => {
    let employeeState = { ...employeeData };
    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "role") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
          setRole(event);
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "gender") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          gender: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "branch") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          branch: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "martialstatus") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          maritalStatus: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "country") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          country: "",
        });

        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "state") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          state: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
          employeeState.city = "";
          employeeState.zipcode = "";
          employeeState.zipcodeStatus = "unchecked";
          employeeState.cityStatus = "unchecked";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "city") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          city: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "shifts") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          shifts: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "countryCode") {
        const lengthRegex = new RegExp("^[A-Za-z0-9\\W]");
        setValidationMessages({
          ...validationMessages,
          countryCode: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "reportingManager") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          reportingManager: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "employeeType") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          employeeType: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "department") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          department: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "designation") {
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        setValidationMessages({
          ...validationMessages,
          designation: "",
        });
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      } else if (selectEvent.name === "categoryType") {
        // const alphaNumberLengthRegex = new RegExp('^([A-Za-z0-9 ]{1,20})$');
        const lengthRegex = new RegExp("^[A-Za-z0-9]");
        if (event?.value == "Category 3") {
          setStep([
            " Personal info",
            "Official info",
            "Salary Details",
            "Bank Details",
          ]);
          setMaxStep(3);
        } else if (event?.value == "Category 4") {
          setStep([" Personal info", "Official info", "Salary Details"]);
          setMaxStep(2);
        } else {
          setStep([
            " Personal info",
            "Official info",
            "Salary Details",
            "Bank Details",
            "PF & ESI Details",
          ]);
          setMaxStep(4);
        }
        if (lengthRegex.test(event?.label) === true) {
          employeeState[selectEvent.name + "Status"] =
            event?.label === undefined ? "unchecked" : "success";
        } else {
          employeeState[selectEvent.name + "Status"] =
            selectEvent.value === "" ? "unchecked" : "error";
        }
      }
      employeeState[selectEvent.name] = event;
    } else {
      const changeAllowed = true;
      switch (event.target.name) {
        case "firstName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");
            setValidationMessages({
              ...validationMessages,
              firstName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "nomineeName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");
            setValidationMessages({
              ...validationMessages,
              firstName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "nomineeRelation":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");
            setValidationMessages({
              ...validationMessages,
              firstName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");
            setValidationMessages({
              ...validationMessages,
              lastName: "",
            });
            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "fathername":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "userName":
          {
            const alphaNLengthRegex = new RegExp("^([a-zA-Z ]{1,20})$");

            if (alphaNLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "dob":
          {
            const enteredDate = new Date(event.target.value);
            const today = new Date();

            const date18YearsAgo = new Date(
              today.getFullYear() - 18,
              today.getMonth(),
              today.getDate(),
            );
            const date60YearsAgo = new Date(
              today.getFullYear() - 60,
              today.getMonth(),
              today.getDate(),
            );

            setValidationMessages({
              ...validationMessages,
              dob: "",
            });

            if (
              enteredDate <= date18YearsAgo &&
              enteredDate >= date60YearsAgo
            ) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "address":
          {
            const alphaNumberLengthRegex = new RegExp("^.{1,250}$", "s");
            setValidationMessages({
              ...validationMessages,
              address: "",
            });
            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "emergencyNumber":
          {
            const phoneRegex = new RegExp("^[0-9]{10}$");

            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "contactNumber":
          {
            const phoneRegex = new RegExp("^[0-9]{10}$");
            setValidationMessages({
              ...validationMessages,
              contactNumber: "",
            });
            if (phoneRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "attendanceId":
          {
            const alphanumericRegex = new RegExp("^[a-zA-Z0-9]{1,20}$");
            setValidationMessages({
              ...validationMessages,
              contactNumber: "",
            });
            if (alphanumericRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "zipcode":
          {
            const zipcodeRegex = new RegExp("^[0-9]{6}$");
            setValidationMessages({
              ...validationMessages,
              zipcode: "",
            });
            if (zipcodeRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "email":
          {
            const emailRegex = new RegExp(/^[\w.-]+@[\w-]+\.(com|in|yahoo)$/g);
            setValidationMessages({
              ...validationMessages,
              email: "",
            });
            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "officialmailid":
          {
            const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);
            setValidationMessages({
              ...validationMessages,
              officialmailid: "",
            });
            if (emailRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "aadharnumber":
          {
            const sanitizedValue = event.target.value
              .replace(/\D/g, "")
              .slice(0, 12);

            const formattedValue = sanitizedValue
              .replace(/(\d{4})(\d+)/, "$1 $2")
              .replace(/(\d{4} \d{4})(\d+)/, "$1 $2");

            const aadharRegex = new RegExp("^\\d{4} \\d{4} \\d{4}$");

            event.target.value = formattedValue;

            setValidationMessages({
              ...validationMessages,
              aadharNumber: "",
            });

            employeeState[event.target.name + "Status"] = aadharRegex.test(
              formattedValue,
            )
              ? "success"
              : formattedValue === ""
                ? "unchecked"
                : "error";
          }
          break;

        case "pannumber":
          {
            const panRegex = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$", "i");
            setValidationMessages({
              ...validationMessages,
              panNumber: "",
            });
            if (panRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "employeeId":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{3,15})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "previousExperience":
          {
            const alphaNumberLengthRegex = /^\d{0,2}(\.\d{0,2})?$/;

            if (alphaNumberLengthRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "joiningDate":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$",
            );
            setValidationMessages({
              ...validationMessages,
              joiningDate: "",
            });
            if (dateLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "lastworking":
          {
            const dateLengthRegex = new RegExp(
              "^[a-zA-Z0-9 !@#$%^&*()_+{}|:\"<>?`\\[\\]\\\\;,./'-=~]{10,150}$",
            );

            if (dateLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "probationPeriod":
          {
            const userRegex = new RegExp("^[a-zA-Z0-9 ]{1,20}$"); // Allows alphanumeric characters and spaces, 1-20 chars
            setValidationMessages({
              ...validationMessages,
              user: "",
            });

            if (userRegex.test(event.target.value)) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "grade":
          {
            const alphaNumberLengthRegex = new RegExp("^([A-Za-z0-9 ]{1,})$");

            if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "enterIfsc":
          {
            const ifscRegex = new RegExp("^[A-Z]{4}0[A-Z0-9]{6}$");
            setValidationMessages({
              ...validationMessages,
              enterIfsc: "",
            });
            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "accountnumber":
          {
            const ifscRegex = new RegExp("^[0-9]{8,34}$");
            setValidationMessages({
              ...validationMessages,
              accountnumber: "",
            });

            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "bankname":
          {
            const ifscRegex = new RegExp("^[A-Za-z ]{1,25}$");
            setValidationMessages({
              ...validationMessages,
              bankname: "",
            });

            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "categoryType":
          {
            const ifscRegex = new RegExp("^[A-Za-z]{1,20}$");
            setValidationMessages({
              ...validationMessages,
              branchname: "",
            });
            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "branchname":
          {
            const ifscRegex = new RegExp("^[A-Za-z ]{1,20}$");
            setValidationMessages({
              ...validationMessages,
              branchname: "",
            });
            if (ifscRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "cifnumber":
          {
            const cifRegex = new RegExp("^[0-9]{8,25}$");
            setValidationMessages({
              ...validationMessages,
              cifnumber: "",
            });

            if (cifRegex.test(event.target.value?.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "uannumber":
          {
            const uanRegex = new RegExp("^[0-9]{12}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "memberid":
          {
            const uanRegex = new RegExp("^[A-Za-z0-9]{1,25}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "esicnumber":
          {
            const uanRegex = /^[0-9]{17,17}$/;
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "accountnumber":
          {
            const uanRegex = new RegExp("^[A-Za-z0-9]{1,25}$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "basicAmount":
          {
            const uanRegex = new RegExp("^[1-9][0-9]{0,5}(\\.[0-9]+)?$");

            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "daAmount":
          {
            const uanRegex = new RegExp("^[1-9][0-9]{0,5}(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "mealsAmount":
          {
            // Regex to validate a 12-digit UAN number
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        case "hraAmount":
          {
            // Regex to validate a 12-digit UAN number
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "otAmount":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "shiftPaisa":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "attendanceAmount":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "pfamount":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "esiamount":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;
        case "busFare":
          {
            const uanRegex = new RegExp("^(0|[1-9][0-9]{0,5})(\\.[0-9]+)?$");
            if (uanRegex.test(event.target.value.trim())) {
              employeeState[event.target.name + "Status"] = "success";
            } else {
              employeeState[event.target.name + "Status"] =
                event.target.value === "" ? "unchecked" : "error";
            }
          }
          break;

        default:
          break;
      }
      if (changeAllowed) {
        employeeState[event.target.name] = event.target.value;
      }
    }
    setEmployeeData(employeeState);
  };

  const handleFileChange = (event, fieldName) => {
    const file = event.target.files[0];

    setEmployeeData((prev) => ({
      ...prev,
      [fieldName]: file,
    }));
  };

  const handleEmployee = (value, fieldName, phonecode) => {
    if (fieldName === "emergencyNumber" || fieldName === "contactNumber") {
      if (value?.length <= phonecode?.length) {
        setEmployeeData((prevData) => ({
          ...prevData,
          [fieldName]: value,
          [`${fieldName}Status`]: "unchecked", // No error when empty
        }));
      } else {
        const mobileNumber = value.substring(phonecode?.length);

        const isValid = /^[0-9]{10}$/.test(mobileNumber);

        setEmployeeData((prevData) => ({
          ...prevData,
          [fieldName]: value, // Keep full number including country code
          [`${fieldName}Status`]: value > phonecode ? "success" : "error",
        }));
      }
    } else {
      setEmployeeData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
    }
  };

  const handleBankDetailsVerification = (verified, type) => {
    setEmployeeData({
      ...employeeData,
      [`is${type}VerifyStatus`]: verified ? "success" : "error",
    });
  };
  useEffect(() => {
    if (employeeData?.employeeType?.value === "Internship") {
      setEmployeeData((prevState) => ({
        ...prevState,
        user: false,
        probationPeriod: false,
      }));
    }
  }, [employeeData?.employeeType?.value]);

  const handleChange = (event) => {
    if (employeeData?.employeeType?.value === "Internship") {
      return;
    }

    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.checked,
    });
  };

  const handleactive = (event) => {
    setEmployeeData({
      ...employeeData,
      [event.target.name]: event.target.checked,
    });
  };

  //Fetch Data by ID
  const getemployeedata = async (id) => {
    const query = `
query UserDetail_By_ID($id: String!) { 
   userDetail(Id: $id) { 
       id 
       firstName 
       lastName 
       fathersName 
       dateOfBirth 
       email 
       gender 
       username 
       empid 
       contactNumber 
       secondaryContactNumber 
       aadharNumber 
       panNumber 
       employeeType 
       category 
       branch 
       maritalStatus 
       address 
       country 
       state 
       city 
       zipCode 
       dateOfJoining 
       LastWorkingDay 
       otApplicable 
       shift 
       esicNumber 
       uanNumber 
       memberId 
       isUser 
       isActive 

      attendanceId 
       role { 
         id 
       } 
       bankDetails { 
         accountNumber 
         bankName 
         ifscNumber 
         branchName 
         cifNumber 
       } 
       salaryDetails { 
         basicAmount 
         daAmount 
         mealsAmountPerDay 
         otAmountPerHour 
         shiftPaisa 
         attendanceAmount 
         busFare 
         esiAmount 
         hraAmount
         pfAmount 
       } 
      aadharAttachment 
      nomineeAadharAttachment 
      panAttachment 
      bankPassbookAttachment 
      nomineeName 
      nomineeRelationship 
     } 
   }  
`;
    const encodedId = btoa(id);

    try {
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id: "VXNlck5vZGU6" + encodedId },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      let result = response.data.data.userDetail;
      setTogglePage({
        ...togglePage,
        view: true,
      });
      if (result?.category == "Category 3") {
        setStep([
          " Personal info",
          "Official info",
          "Salary Details",
          "Bank Details",
        ]);
        setMaxStep(3);
      } else if (result?.category == "Category 4") {
        setStep([" Personal info", "Official info", "Salary Details"]);
        setMaxStep(2);
      } else {
        setStep([
          " Personal info",
          "Official info",
          "Salary Details",
          "Bank Details",
          "PF & ESI Details",
        ]);
        setMaxStep(4);
      }

      if (roledata) {
        const role = roledata?.find((r) => r.id == result?.role?.id);
        setRole({ value: role?.id, label: role?.role });
      }
      console.log(`${BASEURL}media/${result.aadharAttachment}`);

      setEmployeeData({
        firstName: result.firstName,
        lastName: result.lastName,
        activeuser: result.isActive,
        fathername: result.fathersName,
        dob: result.dateOfBirth,
        userName: result.username,
        email: result.email,
        gender: resources.gender.find((g) => g.value === result.gender) || null,
        martialstatus: {
          value: result.maritalStatus,
          label: result.maritalStatus,
        },
        address: result.address,
        country: { value: result?.country, label: result?.country },
        state: { value: result?.state, label: result?.state },
        city: { value: result?.city, label: result?.city },
        zipcode: result.zipCode,
        attendanceId: result?.attendanceId,
        aadharnumber: formatAadharNumber(result.aadharNumber),
        pannumber: result.panNumber,
        employeeId: result.empid,
        contactNumber: result?.contactNumber,

        emergencyNumber: result?.secondaryContactNumber,
        joiningDate: result.dateOfJoining,
        employeeType: {
          value: result?.employeeType,
          label: result?.employeeType,
        },
        categoryType: { value: result?.category, label: result?.category },
        shifts: { value: result?.shift, label: result?.shift },
        branch: { value: result?.branch, label: result?.branch },

        user: result?.otApplicable,
        isuser: result?.isUser,
        employee: result?.isActive,
        basicAmount: result?.salaryDetails?.basicAmount || "",
        daAmount: result?.salaryDetails?.daAmount || "",
        mealsAmount: result?.salaryDetails?.mealsAmountPerDay || "",
        hraAmount: result?.salaryDetails?.hraAmount || "",
        otAmount: result?.salaryDetails?.otAmountPerHour || "",
        shiftPaisa: result?.salaryDetails?.shiftPaisa || "",
        attendanceAmount: result?.salaryDetails?.attendanceAmount || "",
        busFare: result?.salaryDetails?.busFare || "",
        accountnumber: result?.bankDetails?.accountNumber || "",
        bankname: result?.bankDetails?.bankName || "",
        enterIfsc: result?.bankDetails?.ifscNumber || "",
        cifnumber: result?.bankDetails?.cifNumber || "",
        branchname: result?.bankDetails?.branchName || "",
        uannumber: result?.uanNumber || "",
        memberid: result?.memberId || "",
        esicnumber: result?.esicNumber || "",
        lastworking: result?.LastWorkingDay || "",
        esiamount: result?.salaryDetails?.esiAmount,
        pfamount: result?.salaryDetails?.pfAmount,
        aadharImage: result?.aadharAttachment
          ? `${MediaUrl}/media/${result.aadharAttachment}`
          : null,
        nomineeAadharImage: result?.nomineeAadharAttachment
          ? `${MediaUrl}/media/${result.nomineeAadharAttachment}`
          : null,
        panImage: result?.panAttachment
          ? `${MediaUrl}/media/${result.panAttachment}`
          : null,
        bankPassbookImage: result?.bankPassbookAttachment
          ? `${MediaUrl}/media/${result.bankPassbookAttachment}`
          : null,
        nomineeName: result?.nomineeName,
        nomineeRelation: result?.nomineeRelationship,

        firstNameStatus: result.firstName?.trim() ? "success" : "unchecked",
        lastNameStatus: result.lastName?.trim() ? "success" : "unchecked",
        dobStatus: result.dateOfBirth ? "success" : "unchecked",
        emailStatus: result.email?.trim() ? "success" : "unchecked",
        genderStatus: result.gender ? "success" : "unchecked",
        martialstatusStatus: result.maritalStatus ? "success" : "unchecked",
        addressStatus: result.address?.trim() ? "success" : "unchecked",
        stateStatus: result.state ? "success" : "unchecked",
        cityStatus: result.city ? "success" : "unchecked",
        zipcodeStatus: result.zipCode ? "success" : "unchecked",

        aadharnumberStatus: result.aadharNumber ? "success" : "unchecked",
        joiningDateStatus: result.dateOfJoining ? "success" : "unchecked",
        employeeTypeStatus: result.employeeType ? "success" : "unchecked",
        categoryTypeStatus: result.category ? "success" : "unchecked",
        branchStatus: result.branch ? "success" : "unchecked",
        shiftsStatus: result.shift ? "success" : "unchecked",

        basicAmountStatus: result?.salaryDetails?.basicAmount
          ? "success"
          : "unchecked",
        daAmountStatus: result?.salaryDetails?.daAmount
          ? "success"
          : "unchecked",
        roleStatus: result?.role?.id ? "success" : "unchecked",
        mealsAmountStatus: result?.salaryDetails?.mealsAmountPerDay
          ? "success"
          : "unchecked",
        shiftPaisaStatus: result?.salaryDetails?.shiftPaisa
          ? "success"
          : "unchecked",
        otAmountStatus: result?.salaryDetails?.otAmountPerHour
          ? "success"
          : "unchecked",
        attendanceAmountStatus: result?.salaryDetails?.attendanceAmount
          ? "success"
          : "unchecked",
        hraAmountStatus: result?.salaryDetails?.hraAmount
          ? "success"
          : "unchecked",
        busFareStatus: result?.salaryDetails?.busFare ? "success" : "unchecked",

        accountnumberStatus: result?.bankDetails?.accountNumber
          ? "success"
          : "unchecked",
        banknameStatus: result?.bankDetails?.bankName ? "success" : "unchecked",
        enterIfscStatus: result?.bankDetails?.ifscNumber
          ? "success"
          : "unchecked",
        branchnameStatus: result?.bankDetails?.branchName
          ? "success"
          : "unchecked",

        uannumberStatus: result?.uanNumber ? "success" : "unchecked",
        pannumberStatus: result?.panNumber ? "success" : "unchecked",
        fathernameStatus: result?.fathersName ? "success" : "unchecked",

        nomineeNameStatus: result?.nomineeName ? "success" : "unchecked",
        nomineeRelationStatus: result?.nomineeRelationship
          ? "success"
          : "unchecked",
        pfamountStatus: result?.salaryDetails?.pfAmount
          ? "success"
          : "unchecked",
        esiamountStatus: result?.salaryDetails?.esiAmount
          ? "success"
          : "unchecked",
        contactNumberStatus: result?.contactNumber ? "success" : "unchecked",
        memberidStatus: result?.memberId ? "success" : "unchecked",
        esicnumberStatus: result?.esicNumber ? "success" : "unchecked",
        cifnumberStatus: result?.bankDetails?.cifNumber
          ? "success"
          : "unchecked",
        attendanceIdStatus: result?.attendanceId ? "success" : "unchecked",
      });

      setTimeout(() => {
        setEmployeeData((prevFeedback) => ({
          ...prevFeedback,
          contactNumber: result?.contactNumber,
          emergencyNumber: result?.secondaryContactNumber,
        }));
      }, 500);

      setOriginalWeekoffData({
        firstName: result.firstName,
        lastName: result.lastName,
        activeuser: result.isActive,
        fathername: result.fathersName,
        dob: result.dateOfBirth,
        userName: result.username,
        email: result.email,
        gender: resources.gender.find((g) => g.value === result.gender) || null,
        martialstatus:
          resources.martialstatus.find(
            (m) => m.value === result.maritalStatus,
          ) || null,
        address: result.address,
        country: { value: result?.country, label: result?.country },
        state: { value: result?.state, label: result?.state },
        city: { value: result?.city, label: result?.city },
        zipcode: result.zipCode,
        attendanceId: result?.attendanceId,
        aadharnumber: formatAadharNumber(result.aadharNumber),
        pannumber: result.panNumber,
        employeeId: result.empid,
        contactNumber: result?.contactNumber,

        emergencyNumber: result?.secondaryContactNumber,
        joiningDate: result.dateOfJoining,
        employeeType: {
          value: result?.employeeType,
          label: result?.employeeType,
        },
        categoryType: { value: result?.category, label: result?.category },
        shifts: { value: result?.shift, label: result?.shift },
        branch: { value: result?.branch, label: result?.branch },
        role: { value: role?.id, label: role?.role },
        user: result?.otApplicable,
        isuser: result?.isUser,
        employee: result?.isActive,
        basicAmount: result?.salaryDetails?.basicAmount || "",
        daAmount: result?.salaryDetails?.daAmount || "",
        mealsAmount: result?.salaryDetails?.mealsAmountPerDay || "",
        otAmount: result?.salaryDetails?.otAmountPerHour || "",
        shiftPaisa: result?.salaryDetails?.shiftPaisa || "",
        attendanceAmount: result?.salaryDetails?.attendanceAmount || "",
        busFare: result?.salaryDetails?.busFare || "",
        accountnumber: result?.bankDetails?.accountNumber || "",
        bankname: result?.bankDetails?.bankName || "",
        enterIfsc: result?.bankDetails?.ifscNumber || "",
        cifnumber: result?.bankDetails?.cifNumber || "",
        branchname: result?.bankDetails?.branchName || "",
        uannumber: result?.uanNumber || "",
        memberid: result?.memberId || "",
        esicnumber: result?.esicNumber || "",
        lastworking: result?.LastWorkingDay || "",
        esiamount: result?.salaryDetails?.esiAmount,
        pfamount: result?.salaryDetails?.pfAmount,
      });
      setActive(true);
    } catch (error) {
      console.log("ReponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const uploadLink = createUploadLink({ uri: BASEURL });
  const client = new ApolloClient({
    link: uploadLink,
    cache: new InMemoryCache(),
  });
  //Create Mutation Function
  const onEmployeeeSubmit = async () => {
    setCirleLoading(true);

    const query = gql`
      mutation CreateUser($input: UsersDetailsInput!) {
        createUser(input: $input) {
          users {
            id
            firstName
            lastName
            fathersName
            dateOfBirth
            email
            gender
            username
            empid
            contactNumber
            secondaryContactNumber
            aadharNumber
            panNumber
            employeeType
            category
            branch
            maritalStatus
            address
            country
            state
            city
            zipCode
            dateOfJoining
            LastWorkingDay
            otApplicable
            shift
            esicNumber
            uanNumber
            memberId
            isUser
            isActive
            attendanceId
            role {
              id
            }
            bankDetails {
              accountNumber
              bankName
              ifscNumber
              branchName
              cifNumber
            }
            salaryDetails {
              basicAmount
              daAmount
              mealsAmountPerDay
              hraAmount
              otAmountPerHour
              shiftPaisa
              attendanceAmount
              busFare
              esiAmount
              pfAmount
            }
            aadharAttachment
            nomineeAadharAttachment
            panAttachment
            bankPassbookAttachment
            nomineeName
            nomineeRelationship
          }
        }
      }
    `;

    let dataPayload = {
      input: {
        attendanceId: employeeData?.attendanceId,
        firstName: employeeData.firstName,
        lastName: employeeData.lastName,
        fathersName: employeeData.fathername,
        dateOfBirth: employeeData.dob,
        email: employeeData.email,
        gender: employeeData.gender.label,
        maritalStatus: employeeData?.martialstatus?.value,
        address: employeeData.address,
        country: "India",
        state: employeeData.state?.value,
        city: employeeData.city.value,
        zipCode: employeeData.zipcode,
        contactNumber: employeeData.contactNumber,
        secondaryContactNumber: employeeData.emergencyNumber,
        LastWorkingDay: employeeData.lastworking,
        aadharNumber: employeeData.aadharnumber.replace(/\s+/g, ""),
        panNumber: employeeData.pannumber,
        empid: employeeData.employeeId,
        dateOfJoining: employeeData.joiningDate,
        employeeType: employeeData.employeeType.value,
        category: employeeData.categoryType.value,
        shift: employeeData.shifts?.label || "",
        otApplicable: employeeData.user,
        isUser: employeeData.isuser,

        uanNumber: employeeData.uannumber,
        memberId: employeeData.memberid,
        esicNumber: employeeData.esicnumber,
        salutation: "mr",
        branch: employeeData?.branch?.label || "",
        role: {
          id: employeeData?.role?.value || "",
        },
        bankDetails: {
          accountNumber: employeeData.accountnumber,
          bankName: employeeData.bankname,
          ifscNumber: employeeData.enterIfsc,
          branchName: employeeData.branchname,
          cifNumber: employeeData.cifnumber,
        },
        salaryDetails: {
          basicAmount: employeeData.basicAmount,
          daAmount: employeeData.daAmount,
          mealsAmountPerDay: employeeData.mealsAmount,
          hraAmount: employeeData?.hraAmount,
          otAmountPerHour: employeeData.otAmount,
          shiftPaisa: employeeData.shiftPaisa,
          attendanceAmount: employeeData.attendanceAmount,
          busFare: employeeData.busFare,
          esiAmount: employeeData?.esiamount,
          pfAmount: employeeData?.pfamount,
        },
        aadharAttachment: employeeData.aadharImage || null,
        nomineeAadharAttachment: employeeData.nomineeAadharImage || null,
        panAttachment: employeeData.panImage || null,
        bankPassbookAttachment: employeeData.bankPassbookImage || null,
        nomineeName: employeeData.nomineeName,
        nomineeRelationship: employeeData.nomineeRelation,
      },
    };
    try {
      const response = await client.mutate({
        mutation: query,
        variables: {
          input: dataPayload.input,
        },
        // url: BASEURL,
        // method: "POST",
        // headers: {
        //   "Content-Type": "application/json",
        // },
        // data: JSON.stringify({
        //   query,
        //   variables: dataPayload,
        // }),
      });

      if (response.data.createUser) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Created Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Request failed. Check your details and try again.",
          showConfirmButton: false,
          timer: 2500,
        });
      }

      setCirleLoading(false);
    } catch (error) {
      console.error("responseError:", error);
      setCirleLoading(false);
      const message =
        error?.graphQLErrors?.[0]?.message ||
        error?.networkError?.message ||
        "Sorry for the inconvenience, there is some issue in our network. Please try again later.";
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message,
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      employeeData?.categoryType?.value === "Category 4"
        ? employeeData.firstNameStatus === "success" &&
          employeeData.lastNameStatus === "success" &&
          employeeData.dobStatus === "success" &&
          employeeData.emailStatus === "success" &&
          employeeData.genderStatus === "success" &&
          employeeData.martialstatusStatus === "success" &&
          employeeData.addressStatus === "success" &&
          employeeData.stateStatus === "success" &&
          employeeData.cityStatus === "success" &&
          employeeData.zipcodeStatus === "success" &&
          employeeData.aadharnumberStatus === "success" &&
          employeeData.joiningDateStatus === "success" &&
          employeeData.employeeTypeStatus === "success" &&
          employeeData.categoryTypeStatus === "success" &&
          employeeData.branchStatus === "success" &&
          employeeData.shiftsStatus === "success" &&
          employeeData.roleStatus === "success" &&
          employeeData.basicAmountStatus === "success" &&
          employeeData.daAmountStatus === "success" &&
          employeeData.mealsAmountStatus === "success" &&
          employeeData.shiftPaisaStatus === "success" &&
          employeeData.otAmountStatus === "success" &&
          employeeData.attendanceAmountStatus === "success" &&
          employeeData.busFareStatus === "success"
        : employeeData?.categoryType?.value === "Category 3"
          ? employeeData.firstNameStatus === "success" &&
            employeeData.lastNameStatus === "success" &&
            employeeData.dobStatus === "success" &&
            employeeData.emailStatus === "success" &&
            employeeData.genderStatus === "success" &&
            employeeData.martialstatusStatus === "success" &&
            employeeData.addressStatus === "success" &&
            employeeData.stateStatus === "success" &&
            employeeData.cityStatus === "success" &&
            employeeData.zipcodeStatus === "success" &&
            employeeData.aadharnumberStatus === "success" &&
            employeeData.joiningDateStatus === "success" &&
            employeeData.employeeTypeStatus === "success" &&
            employeeData.categoryTypeStatus === "success" &&
            employeeData.otAmountStatus === "success" &&
            employeeData.branchStatus === "success" &&
            employeeData.shiftsStatus === "success" &&
            employeeData.roleStatus === "success" &&
            employeeData.basicAmountStatus === "success" &&
            employeeData.daAmountStatus === "success" &&
            employeeData.mealsAmountStatus === "success" &&
            employeeData.hraAmountStatus === "success" &&
            employeeData.shiftPaisaStatus === "success" &&
            employeeData.attendanceAmountStatus === "success" &&
            employeeData.busFareStatus === "success" &&
            employeeData.accountnumberStatus === "success"
          : employeeData.firstNameStatus === "success" &&
            employeeData.lastNameStatus === "success" &&
            employeeData.dobStatus === "success" &&
            employeeData.emailStatus === "success" &&
            employeeData.genderStatus === "success" &&
            employeeData.martialstatusStatus === "success" &&
            employeeData.addressStatus === "success" &&
            employeeData.stateStatus === "success" &&
            employeeData.cityStatus === "success" &&
            employeeData.zipcodeStatus === "success" &&
            employeeData.aadharnumberStatus === "success" &&
            employeeData.pannumberStatus === "success" &&
            employeeData.joiningDateStatus === "success" &&
            employeeData.employeeTypeStatus === "success" &&
            employeeData.categoryTypeStatus === "success" &&
            employeeData.branchStatus === "success" &&
            employeeData.shiftsStatus === "success" &&
            employeeData.roleStatus === "success" &&
            employeeData.basicAmountStatus === "success" &&
            employeeData.daAmountStatus === "success" &&
            employeeData.mealsAmountStatus === "success" &&
            employeeData.shiftPaisaStatus === "success" &&
            employeeData.otAmountStatus === "success" &&
            employeeData.attendanceAmountStatus === "success" &&
            employeeData.busFareStatus === "success" &&
            employeeData.accountnumberStatus === "success" &&
            employeeData.branchnameStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleAddEmployee = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to submit your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onEmployeeeSubmit();

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const handleUpdateEmployee = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Update your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        Updateempolyeedetails();

        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Mutation Function
  const Updateempolyeedetails = async () => {
    setCirleLoading(true);

    const query = gql`
      mutation UpdateUserDetails($input: UsersDetailsUpdateInput!) {
        updateUser(input: $input) {
          users {
            id
            firstName
            lastName
            fathersName
            dateOfBirth
            email
            gender
            username
            empid
            contactNumber
            secondaryContactNumber
            aadharNumber
            panNumber
            employeeType
            category
            branch
            maritalStatus
            address
            country
            state
            city
            zipCode
            dateOfJoining
            LastWorkingDay
            otApplicable
            shift
            esicNumber
            uanNumber
            memberId
            isUser
            salutation
            isActive
            attendanceId
            role {
              id
            }
            bankDetails {
              accountNumber
              bankName
              ifscNumber
              branchName
              cifNumber
            }
            salaryDetails {
              basicAmount
              daAmount
              mealsAmountPerDay
              otAmountPerHour
              shiftPaisa
              attendanceAmount
              busFare
              hraAmount
              esiAmount
              pfAmount
            }
            aadharAttachment
            nomineeAadharAttachment
            panAttachment
            bankPassbookAttachment
            nomineeName
            nomineeRelationship
          }
        }
      }
    `;

    const encodedId = btoa(id);
    const formattedData = {
      attendanceId: employeeData?.attendanceId,
      id: "VXNlck5vZGU6" + encodedId,
      salutation: "Mr",
      firstName: employeeData.firstName,
      lastName: employeeData.lastName,
      fathersName: employeeData.fathername,
      dateOfBirth: employeeData.dob,
      email: employeeData?.email,
      gender: employeeData.gender?.label || "",
      maritalStatus: employeeData.martialstatus?.value,
      address: employeeData.address,
      category: employeeData.categoryType?.value || "",
      createdBy: addedId[0]?.id,
      country: "India",
      state: employeeData.state?.value || "",
      city: employeeData.city?.value || "",
      zipCode: employeeData.zipcode,
      contactNumber: employeeData.contactNumber,
      secondaryContactNumber: employeeData.emergencyNumber,
      aadharNumber: employeeData.aadharnumber.replace(/\s+/g, ""),
      panNumber: employeeData.pannumber,
      empid: employeeData.employeeId,
      dateOfJoining: employeeData.joiningDate,
      role: Number(role?.value) || null,
      employeeType: employeeData.employeeType?.value || "",
      shift: employeeData.shifts?.label || "",
      otApplicable: employeeData.user,
      isUser: employeeData.isuser,
      uanNumber: employeeData.uannumber,
      memberId: employeeData.memberid,
      esicNumber: employeeData.esicnumber,
      LastWorkingDay: employeeData.lastworking || null,
      isActive: employeeData.employee,
      branch: employeeData.branch?.label || "",

      bankDetails: [
        {
          accountNumber: employeeData.accountnumber || "",
          bankName: employeeData.bankname || "",
          ifscNumber: employeeData.enterIfsc || "",
          branchName: employeeData.branchname || "",
          cifNumber: employeeData.cifnumber || "",
        },
      ],
      salaryDetails: [
        {
          basicAmount: employeeData.basicAmount || null,
          daAmount: employeeData.daAmount || null,
          mealsAmountPerDay: employeeData.mealsAmount || null,
          hraAmount: employeeData?.hraAmount || null,
          otAmountPerHour: employeeData.otAmount || null,
          shiftPaisa: employeeData.shiftPaisa || null,
          attendanceAmount: employeeData.attendanceAmount || null,
          busFare: employeeData.busFare || null,
          esiAmount: employeeData?.esiamount || null,
          pfAmount: employeeData?.pfamount || null,
        },
      ],
      aadharAttachment:
        employeeData.aadharImage instanceof File
          ? employeeData.aadharImage
          : null,
      nomineeAadharAttachment:
        employeeData.nomineeAadharImage instanceof File
          ? employeeData.nomineeAadharImage
          : null,
      panAttachment:
        employeeData.panImage instanceof File ? employeeData.panImage : null,
      bankPassbookAttachment:
        employeeData.bankPassbookImage instanceof File
          ? employeeData.bankPassbookImage
          : null,
      nomineeName: employeeData.nomineeName,
      nomineeRelationship: employeeData.nomineeRelation,
    };

    try {
      const response = await client.mutate({
        mutation: query,
        variables: {
          input: formattedData,
        },
      });

      if (response?.data?.updateUser) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Updated Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      }

      setCirleLoading(false);
    } catch (error) {
      console.error("GraphQL Update Error:", error);
      setCirleLoading(false);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is an issue with our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog((prev) => ({
            ...prev,
            open: false,
          }));
        },
      });
    }
  };

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };

  // Function to move the previous step
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  // Utility function to format aadhar number
  const formatAadharNumber = (aadhar) => {
    return aadhar ? aadhar.replace(/(\d{4})(\d{4})(\d{4})/, "$1 $2 $3") : "";
  };

  const [Active, setActive] = useState(false);
  const MediaUrl = BASEURL.replace(/\/graphql\/?$/, "");

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDepartment();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardDepartment = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

    setEmployeeData({
      firstName: originalWeekoffData?.firstName,
      lastName: originalWeekoffData?.lastName,
      activeuser: originalWeekoffData?.activeuser,
      fathername: originalWeekoffData?.fathername,
      dob: originalWeekoffData?.dob,
      userName: originalWeekoffData?.userName,
      email: originalWeekoffData.email,
      gender: originalWeekoffData?.gender,
      martialstatus: originalWeekoffData?.martialstatus,
      address: originalWeekoffData?.address,
      attendanceId: originalWeekoffData?.attendanceId,
      state: originalWeekoffData?.state,
      city: originalWeekoffData?.city,
      zipcode: originalWeekoffData.zipCode,

      aadharnumber: originalWeekoffData?.aadharnumber,
      pannumber: originalWeekoffData.pannumber,
      employeeId: originalWeekoffData.employeeId,
      contactNumber: originalWeekoffData?.contactNumber,

      emergencyNumber: originalWeekoffData?.emergencyNumber,
      joiningDate: originalWeekoffData.joiningDate,
      employeeType: originalWeekoffData?.employeeType,
      categoryType: originalWeekoffData?.categoryType,
      shifts: originalWeekoffData?.shifts,
      branch: originalWeekoffData?.branch,

      user: originalWeekoffData?.user,
      isuser: originalWeekoffData?.isuser,
      employee: originalWeekoffData?.employee,
      basicAmount: originalWeekoffData?.basicAmount || "",
      daAmount: originalWeekoffData?.daAmount || "",
      mealsAmount: originalWeekoffData?.mealsAmount || "",
      otAmount: originalWeekoffData?.otAmount || "",
      shiftPaisa: originalWeekoffData?.shiftPaisa || "",
      attendanceAmount: originalWeekoffData?.attendanceAmount || "",
      busFare: originalWeekoffData?.busFare || "",
      accountnumber: originalWeekoffData?.accountnumber || "",
      bankname: originalWeekoffData?.bankname || "",
      enterIfsc: originalWeekoffData?.enterIfsc || "",
      cifnumber: originalWeekoffData?.cifnumber || "",
      branchname: originalWeekoffData?.branchname || "",
      uannumber: originalWeekoffData?.uannumber || "",
      memberid: originalWeekoffData?.memberid || "",
      esicnumber: originalWeekoffData?.esicnumber || "",
      lastworking: originalWeekoffData?.lastworking || "",
      esiamount: originalWeekoffData?.esiamount,
      pfamount: originalWeekoffData?.pfamount,
    });
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        ondeleteemployee();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const ondeleteemployee = async () => {
    const query = `
      mutation deleteUsers($id: String!) {
        deleteUsers(id: $id) {
          deleteusers
        }
      }
    `;
    const encodedId = btoa(id);
    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: { id: "VXNlck5vZGU6" + encodedId },
      });

      let data = response.data.data.deleteUsers;

      if (data) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Employee Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/employee-management");
      }
      return response.data;
    } catch (error) {
      console.error("Error deleting user:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Grid container justifyContent="center">
        <Grid item xs={12} sm={12}>
          <Grid container justifyContent="center" alignItems="center">
            <Grid item xs={9} sm={9}>
              <Card>
                <CardHeader
                  title={
                    <>
                      {togglePage.view === true || togglePage.edit === true ? (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              {togglePage.view
                                ? "View Employee details"
                                : "Update Employee details"}
                            </MaterialTypography>
                          </Stack>
                          {
                            AccessData &&
                              Array.isArray(AccessData) &&
                              AccessData.some(
                                (item) =>
                                  item.component === "EditEmployee" &&
                                  item.can_access,
                              ) && (
                                <ButtonGroup
                                  variant="outlined"
                                  aria-label="Loading button group"
                                >
                                  <MaterialButton
                                    variant="gradient"
                                    color="dark"
                                    onClick={toggleEdit}
                                    startIcon={<EditIcon />}
                                  >
                                    Edit
                                  </MaterialButton>
                                  <MaterialButton
                                    variant="gradient"
                                    color="dark"
                                    onClick={AddDelete}
                                    startIcon={<DeleteIcon />}
                                  >
                                    Delete
                                  </MaterialButton>
                                </ButtonGroup>
                              )
                            // )
                          }
                        </Stack>
                      ) : (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Add Employee Details
                            </MaterialTypography>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  }
                />
                <CardContent sx={{ minHeight: "80vh" }}>
                  <MaterialBox>
                    <Stepper
                      activeStep={activeStep}
                      alternativeLabel
                      style={{
                        padding: "0px",
                        marginTop: "40px",
                        marginBottom: "20px",
                      }}
                    >
                      {steps.map((label) => (
                        <Step key={label}>
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>

                    {activeStep === 0 && (
                      <PersonalInformation
                        handleFileChange={handleFileChange}
                        employeeData={employeeData}
                        handleEmployeeDataChange={handleEmployeeDataChange}
                        resources={resources}
                        togglePage={togglePage}
                        allbranchnames={allbranchnames}
                        handleEmployee={handleEmployee}
                      />
                    )}
                    {activeStep === 1 && (
                      <EmployeeInformation
                        employeeData={employeeData}
                        handleEmployeeDataChange={handleEmployeeDataChange}
                        reportManager={reportManager}
                        allbranchnames={allbranchnames}
                        roledata={roledata}
                        typedata={typedata}
                        department={department}
                        togglePage={togglePage}
                        Active={Active}
                        handleactive={handleactive}
                        emptype={emptype}
                        role={role}
                        designation={designation}
                        resources={resources}
                        branchdata={branchdata}
                        shiftdata={shiftdata}
                        probationOptions={probationOptions}
                        handleChange={handleChange}
                      />
                    )}

                    {activeStep === 2 && (
                      <SalaryDetails
                        employeeData={employeeData}
                        togglePage={togglePage}
                        handleEmployeeDataChange={handleEmployeeDataChange}
                        handleBankDetailsVerification={
                          handleBankDetailsVerification
                        }
                      />
                    )}
                    {activeStep === 3 && (
                      <BankDetails
                        employeeData={employeeData}
                        togglePage={togglePage}
                        handleFileChange={handleFileChange}
                        handleEmployeeDataChange={handleEmployeeDataChange}
                        handleBankDetailsVerification={
                          handleBankDetailsVerification
                        }
                      />
                    )}
                    {activeStep === 4 && (
                      <PFDetails
                        employeeData={employeeData}
                        togglePage={togglePage}
                        resources={resources}
                        handleEmployeeDataChange={handleEmployeeDataChange}
                        handleBankDetailsVerification={
                          handleBankDetailsVerification
                        }
                      />
                    )}
                  </MaterialBox>
                </CardContent>

                <CardActions>
                  <MaterialBox
                    p={2}
                    mt={3}
                    width="100%"
                    display="flex"
                    justifyContent="space-between"
                  >
                    {activeStep === 0 ? (
                      <MaterialBox />
                    ) : (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                        onClick={handleBack}
                      >
                        <NavigateBeforeIcon />
                        prev
                      </MaterialButton>
                    )}
                    {togglePage.edit && activeStep === maxStep && (
                      <>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          style={{ marginLeft: "65%" }}
                          //  disabled={pageState.state === "submitting"}
                          onClick={AddDiscard}
                        >
                          Discard
                        </MaterialButton>
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          // style={{ marginLeft: "44%" }}
                          disabled={!checkAllFields()}
                          onClick={handleUpdateEmployee}
                        >
                          Update
                        </MaterialButton>
                      </>
                    )}
                    {activeStep === maxStep &&
                      !EmpSubmit &&
                      !togglePage.view &&
                      !togglePage?.edit && (
                        <MaterialButton
                          variant="gradient"
                          color="dark"
                          // onClick={handleSubmit}
                          style={{
                            maxWidth: "100px",
                            minWidth: "100px",
                            marginLeft: "65%",
                          }}
                          disabled={!checkAllFields()}
                          onClick={() => handleAddEmployee()}
                        >
                          Submit
                        </MaterialButton>
                      )}

                    {activeStep !== maxStep && (
                      <MaterialButton
                        variant="gradient"
                        color="dark"
                        onClick={handleNext}
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                      >
                        next
                        <NavigateNextIcon />
                      </MaterialButton>
                    )}
                  </MaterialBox>
                </CardActions>
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default AddEmployee;
